/**
 * NotFound (404)
 * Displayed when the user navigates to a non-existent route.
 */

import { Button, Space } from 'antd';
import { IconArrowLeft, IconHome } from './icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PageContainer } from './primitives';

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageContainer>
      <div className="lms-notfound">
        <div className="lms-notfound__code" aria-hidden="true">
          404
        </div>
        <h1 className="lms-notfound__title">
          {t('errors.pageNotFoundTitle')}
        </h1>
        <p className="lms-notfound__description">
          {t('errors.pageNotFound')}
        </p>
        <Space size="small" wrap>
          <Button icon={<IconArrowLeft />} onClick={() => navigate(-1)}>
            {t('errors.goBack')}
          </Button>
          <Button type="primary" icon={<IconHome />} onClick={() => navigate('/')}>
            {t('errors.goHome')}
          </Button>
        </Space>
      </div>
    </PageContainer>
  );
};

export default NotFound;
